module.exports = __webpack_public_path__ + "img/paragon logo website.c0d75a5f.png";